import {SunnyOutline} from "react-ionicons";

export default function SunIcon() {
  return (
    <SunnyOutline color="var(--yellow)" />
  )
}
